//#region IMPORT
import React from 'react';
/** Services Import */
/** Components Import */
import { Box, Stack } from '@mui/material';
import M_TBG_BASIC_01F from './M_TBG_BASIC_01F'; // 영상 교육
import M_TBG_BASIC_02F from './M_TBG_BASIC_02F'; // 중간 다이어로그
import M_TBG_BASIC_03F from './M_TBG_BASIC_03F'; // pdf 교육
import M_TBG_BASIC_04F from './M_TBG_BASIC_04F'; // 작업계획서
import M_TBG_BASIC_05F from './M_TBG_BASIC_05F'; // 작업허가서
import M_TBG_BASIC_06F from './M_TBG_BASIC_06F'; // 중간 다이어로그
import M_TBG_BASIC_07F from './M_TBG_BASIC_07F'; // 추가 회의
import M_TBG_BASIC_08F from './M_TBG_BASIC_08F'; // TBM 회의
import M_TBG_BASIC_09F from './M_TBG_BASIC_09F'; // TBM 완료
//#endregion

function CustomLineStepper({ activeStep, steps }) {
  console.log(activeStep);

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxSizing: 'border-box',
        px: 2,
        py: 2,
      }}
    >
      {Array.from({ length: steps }).map((_, index) => (
        <Box
          key={index}
          sx={{
            flex: 1,
            height: 4,
            backgroundColor: index <= activeStep ? '#33ABD1' : '#e0e0e0',
            borderRadius: 2,
            ml: index === 0 ? 0 : 1, // 왼쪽에만 마진 주기
          }}
        />
      ))}
    </Box>
  );
}

function M_TBG_BASIC(props) {
  //#region 변수
  const components = [
    // 동영상 교육
    <M_TBG_BASIC_01F
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      startTimeRef={props.startTimeRef}
      tbmCdRef={props.tbmCdRef}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // 중간 다이어로그
    <M_TBG_BASIC_02F
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      check={props.check}
      setCheck={props.setCheck}
      tbmCdRef={props.tbmCdRef}
      startTimeRef={props.startTimeRef}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // pdf 교육
    <M_TBG_BASIC_03F
      tbmCdRef={props.tbmCdRef}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // 작업계획서
    <M_TBG_BASIC_04F
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // 작업허가서
    <M_TBG_BASIC_05F
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // 중간 다이어로그
    <M_TBG_BASIC_06F
      userCount={props.userCount}
      setUserCount={props.setUserCount}
      check={props.check}
      setCheck={props.setCheck}
      tbmCdRef={props.tbmCdRef}
      startTimeRef={props.startTimeRef}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // 추가회의
    <M_TBG_BASIC_07F
      tbmCdRef={props.tbmCdRef}
      startTimeRef={props.startTimeRef}
    />,
    // 회의 내용 입력
    <M_TBG_BASIC_08F
      tbmCdRef={props.tbmCdRef}
      //함수
      ActiveButton={props.ActiveButton}
    />,
    // tbm 완료
    <M_TBG_BASIC_09F tbmCdRef={props.tbmCdRef} TbmEnd={props.TbmEnd} />,
  ];
  //#endregion

  return (
    <Box sx={{ backgroundColor: '#F3F7F8', height: 'calc(100vh - 56px)' }}>
      <Stack sx={{ width: '100%', height: '100%' }}>
        <CustomLineStepper
          activeStep={props.activeStep}
          steps={components.length}
        />
        {components[props.activeStep] || null}
      </Stack>
    </Box>
  );
}

export default M_TBG_BASIC;
